<template>
  <div class="info">
    <ul class="namebox">
      <li class="infoitems">
        <div class="item-left">
          <span class="requiretip">*</span>
          <span class="">项目名称</span>
        </div>
        <div class="item-right"
             v-if="operationStatus=='0'"
             @click="getProjectName">
          <span v-if="formData.order_id">{{projectList[formData.order_id]}}</span>
          <span v-else
                class="c_666">请选择</span>
        </div>
        <div class="item-right"
             v-else>
          <span v-if="formData.order_id">{{projectList[formData.order_id]}}</span>
        </div>
      </li>
      <li class="infoitems">
        <div class="item-left">
          <span class="requiretip">*</span>
          <span class="">开票名称</span>
        </div>
        <div class="item-right">
          <input type="text"
                 v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                 class="input-right"
                 v-model="formData.project_name"
                 placeholder="不填则默认是项目名称">
          <span v-else>{{formData.project_name}}</span>

        </div>
      </li>
      <li class="infoitems">
        <div class="item-left">
          <span class="requiretip">*</span>
          <span class="">甲方名称</span>
        </div>
        <div class="item-right">
          <input type="text"
                 v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                 class="input-right"
                 v-model="formData.company_name"
                 placeholder="请输入甲方名称">
          <span v-else>{{formData.company_name}}</span>
        </div>
      </li>
      <li class="intelligence">
        <div class="full-title">
          <span>智能录入开票信息</span>
          <span class="ishow"
                @click="showBtn()">{{isShow?'收起':'展开'}}</span>
        </div>
        <div v-if="isShow">
          <div class="full-info">
            <textarea class="full-input"
                      placeholder="抬头类型：单位
 抬头：XXXX有限公司
 税号：91460200XXXXXX
 单位地址：海南省三亚市XXXXA
 电话号码：0000000000
 开户银行：中国XXXX支行
 银行账户：0000 0000 0000 0000 0000"
                      v-model="bill_string"></textarea>
          </div>
          <div style="overflow:hidden">
            <span class="intelligencebtn"
                  @click="intelligenceBtn">智能识别</span>
          </div>
        </div>
      </li>
    </ul>
    <ul class="accountbox">
      <li class="infoitems">
        <div class="item-left">
          <span class="requiretip">*</span>
          <span class="">事业部选择</span>
        </div>
        <div class="item-right"
             @click="selectGroup" v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'">
          <span v-if="formData.account">{{accountList[formData.account]}}</span>
          <span style="color:#666"
                v-else>请选择</span>
        </div>
         <div class="item-right"
            v-else>
          <span v-if="formData.account">{{accountList[formData.account]}}</span>
        </div>
      </li>
      <li class="infoitems">
        <div class="item-left">
          <span class="requiretip">*</span>
          <span class="">纳税识别号</span>
        </div>
        <div class="item-right">
          <input type="text"
                 v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                 class="input-right"
                 v-model="formData.taxpayer_num"
                 placeholder="请输入">
          <span v-else>{{formData.taxpayer_num}}</span>
        </div>
      </li>
      <li class="infoitems">
        <div class="item-left">
          <span class="requiretip">*</span>
          <span class="">开票开户银行</span>
        </div>
        <div class="item-right">
          <input type="text"
                 v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                 class="input-right"
                 v-model="formData.inv_bank_name"
                 placeholder="请输入">
          <span v-else>{{formData.inv_bank_name}}</span>
        </div>
      </li>
      <li class="infoitems">
        <div class="item-left">
          <span class="requiretip">*</span>
          <span class="">开票银行账号</span>
        </div>
        <div class="item-right">
          <input type="text"
                 v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                 class="input-right"
                 v-model="formData.inv_bank_account"
                 placeholder="请输入">
          <span v-else>{{formData.inv_bank_account}}</span>
        </div>
      </li>
      <li class="infoitems">
        <div class="item-left">
          <span class="requiretip">*</span>
          <span class="">开票电话</span>
        </div>
        <div class="item-right">
          <input type="text"
                 v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                 class="input-right"
                 v-model="formData.inv_phone"
                 placeholder="请输入">
          <span v-else>{{formData.inv_phone}}</span>
        </div>
      </li>
      <li class="infoitems">
        <div class="item-left">
          <span class="requiretip">*</span>
          <span class="">开票地址</span>
        </div>
        <div class="item-right">
          <input type="text"
                 v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                 class="input-right"
                 v-model="formData.inv_address"
                 placeholder="请输入">
          <span v-else>{{formData.inv_address}}</span>
        </div>
      </li>
      <li class="remark-box">
        <div class="remark-title">
           <span class="requiretip">*</span>
           <span>发票栏备注内容</span>
           </div>
        <textarea class="remark-input"
                  v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                  v-model="formData.rev_remark"
                  placeholder="请输入发票是否需要备注，若需要，清输入备注内容"></textarea>
        <textarea class="remark-input"
                  v-else
                  disabled
                  v-model="formData.rev_remark"
                  placeholder="请输入发票是否需要备注，若需要，清输入备注内容"></textarea>
      </li>
    </ul>
    <ul class="accountbox">
      <li>
        <div class="radioitems">
          <span class="requiretip">*</span>
          <span class="">对方企业性质</span>
        </div>
        <div class="radio"
             v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'">
          <mt-radio align="left"
                    v-model="formData.company_char"
                    :options="companyNature">
          </mt-radio>
        </div>
        <div v-else>
          <div class="margin-l"><span class="circle"></span>小规模纳税人</div>
          <div class="margin-l"><span class="circle"></span> 一般纳税人 </div>
        </div>
      </li>
      <li>
        <div class="radioitems">
          <span class="requiretip">*</span>
          <span class="">开票类型</span>
        </div>
        <div class="radio"
             v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'">
          <mt-radio align="left"
                    v-model="formData.inv_type"
                    :options="billingType">
          </mt-radio>
        </div>
        <div v-else>
          <div class="margin-l"><span class="circle"></span>增值税专用发票</div>
          <div class="margin-l"><span class="circle"></span> 增值税普通发票 </div>
        </div>
      </li>
      <li>
        <div class="radioitems">
          <span class="requiretip">*</span>
          <span class="">发票是否邮寄</span>
        </div>
        <div class="radio"
             v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'">
          <mt-radio align="left"
                    v-model="formData.need_mail"
                    :options="needMail">
          </mt-radio>
        </div>
        <div v-else>
          <div class="margin-l"><span class="circle"></span>是</div>
          <div class="margin-l"><span class="circle"></span> 否 </div>
        </div>

      </li>
      <li>
        <!-- 收件信息 -->
        <div v-if="formData.need_mail==1">
      <li class="infoitems">
        <div class="item-left">
          <span class="requiretip">*</span>
          <span class="">收件人</span>
        </div>
        <div class="item-right">
          <input type="text"
                 v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                 class="input-right"
                 v-model="formData.mail_user"
                 placeholder="请输入">
          <span v-else>{{formData.mail_user}}</span>
        </div>
      </li>
      <li class="infoitems">
        <div class="item-left">
          <span class="requiretip">*</span>
          <span class="">收件人电话</span>
        </div>
        <div class="item-right">
          <input type="text"
                 v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                 class="input-right"
                 v-model="formData.mail_phone"
                 placeholder="请输入">
          <span v-else>{{formData.mail_phone}}</span>
        </div>
      </li>
      <li>
        <div class="address-title">
          <span class="requiretip">*</span>
          <span class="">收件地址</span>
        </div>
        <div class="address-box">
          <textarea class="remark-input"
                    v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'"
                    v-model="formData.mail_address"
                    placeholder="请输入"></textarea>
          <textarea v-else
                    class="remark-input"
                    disabled
                    v-model="formData.mail_address"
                    placeholder="请输入"></textarea>
        </div>

      </li>
  </div>
  <!-- 收件信息 -->
  </li>
  </ul>
  <!-- 审核类型 -->
  <ul class="accountbox"
      style="padding-bottom:0;">
    <li>
      <div class="radioitems">
        <span class="requiretip">*</span>
        <span class="">审核类型</span>
      </div>
      <div class="radio"
           v-if="reviewState=='0'||reviewState=='1'||reviewState=='4'||reviewState=='5'">
        <mt-radio align="left"
                  v-model="formData.type"
                  :options="reviewType">
        </mt-radio>
      </div>
      <div v-else>
        <div class="margin-l"><span class="circle"></span>正常</div>
        <div class="margin-l"><span class="circle"></span>特殊</div>
      </div>
    </li>
  </ul>
  <ul>
    <li>
      <div class="leader">
        <p class="leader_title">审批人</p>
        <div>
          <!--正常-->
          <div class="userimg"
               v-if="formData.type==1">
            <img src="../../assets/img/user-avatar.png"
                 alt=""
                 class="img02">
            <span class="avatar-name">陈</span>
            <div class="review-name">陈明玲</div>
          </div>
          <!--特殊-->
          <div v-if="formData.type==2">
            <ul class="all_leader">
              <li style="margin-left:0.3rem">
                <img src="../../assets/img/user-avatar.png"
                     alt=""
                     class="img02">
                <span class="dasheline"></span>
                <span class="avatar-name">{{leader.name?leader.name.slice(0,1):'未知'}}</span>
                <div class="review-name">{{leader.name}}</div>
              </li>
              <li>
                <img src="../../assets/img/user-avatar.png"
                     alt=""
                     class="img02">
                <span class="dasheline"></span>
                <span class="avatar-name">孙</span>
                <div class="review-name">孙文博</div>
              </li>
              <li>
                <img src="../../assets/img/user-avatar.png"
                     alt=""
                     class="img02">
                <span class="avatar-name">陈</span>
                <div class="review-name">陈明玲</div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </li>
  </ul>
  <!-- 审核类型 -->
  <!-- 底部弹窗，筛选数据begin -->
  <mt-popup v-model="PopupVisible"
            position="bottom"
            popup-transition="popup-fade"
            style="width:100%">
    <mt-picker :slots="newAccountList"
               @change="onVisitChange"
               valueKey="name"></mt-picker>
    <div class="footer">
      <span @click="cancelBtn">取消</span>
      <span @click="confirmBtn"
            class="confirm">确认</span>
    </div>
  </mt-popup>
  <!-- 底部弹窗，筛选数据begin -->
  </div>
</template>

<script>


  import { Radio, MessageBox, Popup, Picker } from 'mint-ui';
  import Vue from 'vue'
  Vue.component(Radio.name, Radio);
  Vue.component(Picker.name, Picker);
  Vue.component(Popup.name, Popup);

  export default {
    props: {
      infoFieldState: {
        type: Object,
        default: () => {
          return {}
        }
      },
      editBaseData: {
        type: Object,
        default: () => {
          return {}
        }
      },
      operationStatus: {//操作步骤
        type: String,
        default: () => {
          return '0'
        }
      },
    },

    data () {
      return {
        isShow: true,
        projectList: [],//项目列表
        taxList: [],//税率列表
        accountList: [],
        newAccountList: [],//新的部门数组
        newAccountArr: [],//临时数据
        bill_string: '',//智能填充参数
        PopupVisible: false,
        tempAccount: '',//临时的事业部数组
        leader: {},

        formData: {
          id: '0',
          order_id: '',//	订单id
          project_name: '',// 项目名称
          company_name: '',//甲方名称
          account: '',//事业部
          taxpayer_num: '',//纳税识别号
          inv_bank_name: '',//开票开户银行
          inv_bank_account: '',//开票银行账号
          inv_phone: '',//开票电话
          inv_address: '',//开票地址
          rev_remark: '',//发票栏备注
          company_char: '1',//企业性质
          inv_type: '1',//开票类型
          need_mail: '2',//是否开票
          mail_user: '',//收件人
          mail_phone: '',//收件人电话
          mail_address: '',//收件地址
          type: '1',//审核类型
          higher_uid: 0,//上级uid，一般情况下默认是0，特殊是leader.id
          reviewState: '',//审核状态


        },
        companyNature: [//企业性质
          {
            label: '小规模纳税人',
            value: '1',
            disabled: false
          },
          {
            label: '一般纳税人',
            value: '2',
            disabled: false
          },
        ],

        billingType: [//开票类型
          {
            label: '增值税专用发票',
            value: '1',
          },
          {
            label: '增值税普通发票',
            value: '2'
          },
        ],

        needMail: [//是否邮寄
          {
            label: '是',
            value: '1',
          },
          {
            label: '否',
            value: '2'
          },
        ],
        reviewType: [//审核类型
          {
            label: '正常',
            value: '1',
          },
          {
            label: '特殊',
            value: '2',
          },
        ],

        // 配置验证项目
        ruleValidate: {
          order_id: {
            require: true,
            mesg: '项目名称不能为空'
          },
          project_name: {
            require: true,
            mesg: '开票名称不能为空'
          },
          company_name: {
            require: true,
            mesg: '甲方名称不能为空'
          },
          account: {
            require: true,
            mesg: '事业部不能为空'
          },
          taxpayer_num: {
            require: true,
            mesg: '纳税识别号不能为空'
          },
          inv_bank_name: {
            require: true,
            mesg: '开票开户银行不能为空'
          },
          inv_bank_account: {
            require: true,
            mesg: '开票银行账号不能为空'
          },
          inv_phone: {
            require: true,
            mesg: '开票电话不能为空'
          },
          inv_address: {
            require: true,
            mesg: '开票地址不能为空'
          },
          rev_remark: {
            require: true,
            mesg: '发票栏备注不能为空'
          },
          company_char: {
            require: true,
            mesg: '企业性质不能为空'
          },
          inv_type: {
            require: true,
            mesg: '开票类型不能为空'
          },
        }
      }
    },
    watch: {
      accountList (res) {
        if (res) {
          Object.keys(res).map((item, key) => {
            this.newAccountArr.push({ id: key + 1, name: res[key + 1] })
          })
          this.newAccountArr.unshift({ id: '0', name: '请选择' })
          this.newAccountList = [{
            flex: 1,
            values: this.newAccountArr || [],
            textAlign: 'center'
          }]
        }
      },

      'formData.type' (val) {//监听审核类型
        if (val == 2) {
          this.formData.higher_uid = this.leader.id
        }
      },




    },

    methods: {
      getList () {//获取列表数据
        this.$http.getOpenTicketListdata().then(res => {
          this.projectList = res.data.project_list//项目列表
          this.taxList = res.data.tax_list//税率
          this.accountList = res.data.account_list//事业部
        })
      },
      getLeader () { //领导的id和name值
        this.$http.getInvoicingEdit({}).then(res => {
          this.leader = res.data.leader
        })
      },
      selectGroup () {//选择事业部
        this.PopupVisible = true
      },
      onVisitChange (event) {
        this.tempAccount = event.values['0'].id//事业部

      },
      showBtn () {//智能识别的展开收起
        this.isShow = !this.isShow
      },
      intelligenceBtn () {
        this.$http.getInvoiceanalysis({ bill_string: this.bill_string }).then(res => {
          if (res.errCode == 0) {
            MessageBox('提示', '识别成功')
            this.formData.company_name = res.data.company_name//甲方名称
            this.formData.inv_address = res.data.inv_address//开票地址
            this.formData.inv_bank_account = res.data.inv_bank_account//开户行账号
            this.formData.inv_bank_name = res.data.inv_bank_name//开户行
            this.formData.inv_phone = res.data.inv_phone//开票电话
            this.formData.taxpayer_num = res.data.taxpayer_num//

          }else {
            MessageBox('提示', res.errMsg)
          }
        })
      },
      getProjectName () {//获取项目名称

        this.$router.push({ name: 'allproject', query: { proList: this.projectList } })
        let data = this.$route.params.proId

      },
      cancelBtn () {//事业部选择取消按钮
        this.PopupVisible = false
      },
      confirmBtn () {//选择事业部确定按钮
        this.PopupVisible = false
        this.formData.account = this.tempAccount//临时事业部id
      },
      // 验证当前form带requiretip 类名的字段
      checkField () {
        let fieldState = true
        let keyArr = Object.keys(this.ruleValidate)
        for (let i = 0; i < keyArr.length; i++) {
          if (this.ruleValidate[keyArr[i]].require && this.formData[keyArr[i]] == '') {
            MessageBox('提示', this.ruleValidate[keyArr[i]].mesg)
            fieldState = false
            break
          }
        }
        // 如果验证通过则返回当前组件的forData
        if (fieldState) {
          return this.formData
        }
      }
    },

    created () {
      this.getList()
      this.getLeader()
      this.reviewState = window.localStorage.getItem('reviewState')
      if (this.$route.query.name) {
        this.formData.project_name = this.$route.query.name
      }
      if (this.$route.query.orderId) {
        this.formData.order_id = this.$route.query.orderId
      }

      if (this.infoFieldState.account) {//保存并下一步得到的数据

        let { company_name, account, taxpayer_num, inv_bank_name, inv_bank_account, inv_phone, inv_address, rev_remark, company_char, inv_type, need_mail, mail_user, mail_phone, mail_address, type, higher_uid, } = this.infoFieldState
        this.formData = {
          id: 0,
          order_id: this.$route.query.orderId,//	订单id
          project_name: this.$route.query.name,// 项目名称
          company_name,//甲方名称
          account,//事业部
          taxpayer_num,//纳税识别号
          inv_bank_name,//开票开户银行
          inv_bank_account,//开票银行账号
          inv_phone,//开票电话
          inv_address,//开票地址
          rev_remark: rev_remark ? rev_remark : '无',//发票栏备注
          company_char: company_char ? String(company_char) : '1',//企业性质
          inv_type: inv_type ? String(inv_type) : '1',//开票类型
          need_mail: need_mail ? String(need_mail) : '2',//是否开票
          mail_user,//收件人
          mail_phone,//收件人电话
          mail_address,//收件地址
          type: type ? type : '1',//审核类型
          higher_uid: higher_uid ? higher_uid : '0',//上级uid，一般情况下默认是0，特殊是leader.id
        }
      }
      if (this.operationStatus == '1' && this.editBaseData) {//编辑的数据
        let { id, order_id, project_name, company_name, account, taxpayer_num, inv_bank_name, inv_bank_account, inv_phone, inv_address, rev_remark, company_char, inv_type, need_mail, mail_user, mail_phone, mail_address, type, higher_uid, } = this.editBaseData
        this.formData = {
          id,
          project_name,
          order_id: order_id,//	订单id
          project_name,// 项目名称
          company_name,//甲方名称
          account,//事业部
          taxpayer_num,//纳税识别号
          inv_bank_name,//开票开户银行
          inv_bank_account,//开票银行账号
          inv_phone,//开票电话
          inv_address,//开票地址
          rev_remark,//发票栏备注
          company_char: String(company_char),//企业性质
          inv_type: String(inv_type),//开票类型
          need_mail: String(need_mail),//是否开票
          mail_user,//收件人
          mail_phone,//收件人电话
          mail_address,//收件地址
          type,//审核类型
          higher_uid,//上级uid，一般情况下默认是0，特殊是leader.id
        }
      }


    }
  }
</script>
<style scoped>
  .info {
    margin-top: 0.1rem;
    font-size: 0.4rem;
    padding-bottom: 1.4rem;
  }
  .namebox,
  .accountbox {
    background: #fff;
    padding: 0 0.1rem 0.25rem;
    margin-top: 0.25em;
  }
  .infoitems {
    height: 1.25rem;
    line-height: 1.25rem;
    display: flex;
    position: relative;
    padding: 0 0.1rem;
  }
  .infoitems:after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 1px;
    background: #d8d8d8;
    width: 100%;
    height: 1px;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
  }
  .requiretip {
    color: #fb2e45;
  }
  .item-left {
    width: 33%;
    text-align: left;
  }
  .item-right {
    width: 67%;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .input-right {
    width: 100%;
    text-align: right;
  }
  .intelligence {
    width: 100%;
    text-align: left;
    padding: 0 0.3rem;
  }
  .full-title {
    height: 1.25rem;
    line-height: 1.25rem;
    padding-left: 0.2rem;
  }
  .ishow {
    color: #5483d2;
    float: right;
  }
  .full-info {
    height: 2.907rem;
  }
  .full-input {
    width: 100%;
    height: 100%;
    background: #f7f7f7;
    padding: 0.1rem;
  }
  .intelligencebtn {
    color: #5483d2;
    float: right;
    border: 1px solid #5483d2;
    height: 0.85rem;
    line-height: 0.85rem;
    padding: 0 0.3rem;
    margin-top: 0.2rem;
    border-radius: 0.4rem;
  }
  .remark-box {
    /* padding: 0 0.1rem; */
    margin:0 0.1rem;
  }
  .remark-title {
    height: 1.2rem;
    line-height: 1.2rem;
  }
  .remark-input {
    height: 1.75rem;
    padding: 0.1rem;
    width: 100%;
    background: #f7f7f7;
  }
  .radioitems {
    padding-top: 0.4rem;
    height: 1.1rem;
    margin-left: 0.1rem;
  }
  .radio /deep/ .mint-cell-wrapper {
    padding: 0;
    font-size: 0.4rem;
  }
  .address-title {
    padding: 0.35rem 0.1rem;
  }
  .address-box {
    padding: 0 0.1rem;
  }
  .address-input {
    background: #f7f7f7;
  }
  .leader {
    background: #fff;
  }
  .leader_title {
    background: #f7f7f7;
    padding: 0.35rem;
  }
  .img02 {
    width: 48px;
    height: 48px;
    position: relative;
    top: 10px;
  }
  .avatar-name {
    position: relative;
    top: -7px;
    left: -38px;
    font-size: 20px;
  }
  .userimg {
    padding-left: 10px;
    height: 2.4rem;
  }
  .all_leader {
    display: flex;
  }
  .review-name {
    margin: 0.2rem;
  }
  .dasheline {
    position: absolute;
    top: 1rem;
    right: 0.3rem;
    display: inline-block;
    width: 1.4rem;
    border-bottom: 1px dashed #ccc;
  }
  .all_leader > li {
    flex: 1;
    position: relative;
  }
  .c_666 {
    color: #666;
  }
  .footer {
    width: 100%;
    height: 1.25rem;
    font-size: 0;
  }
  .footer span {
    width: 50%;
    height: 1.125rem;
    font-size: 0.5rem;
    line-height: 1.25rem;
    display: inline-block;
    text-align: center;
  }
  .confirm {
    color: #5483d2;
  }
  .margin-l {
    padding-top: 0.3rem;
    margin: 0 0.2rem;
    height: 1rem;
  }
  .circle {
    margin-right: 0.2rem;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 50%;
    width: 0.5rem;
    height: 0.5rem;
    position: relative;
    top: 0.1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/Ticket/TicketInfo.vue